import React, { useEffect, useState, useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLookUpDropdownListQuery } from '../../api';
import { useLanguage } from '../../contexts/LanguageContext';

const LaborGroupDropdown = ({ value, onChange, className, placeholder }) => {
    const { getCurrentLanguageId } = useLanguage();
    const [selectedLaborGroup, setSelectedLaborGroup] = useState(null);

    const { data: laborGroupList = [], isLoading } = useGetLookUpDropdownListQuery({
        RowCount: 100,
        GroupCode: 'XXBOS_AFTER_LABOR_GROUP',
        LanguageId: getCurrentLanguageId()
    });

    const laborGroupOptions = useMemo(() => {
        return laborGroupList.map((group) => ({
            id: group.id,
            text: group.translatedText,
            displayValue: group.translatedText
        }));
    }, [laborGroupList]);

    const handleSelectionChange = (e) => {
        setSelectedLaborGroup(e.value);
        onChange(e.value ? e.value.id : '');
    };

    useEffect(() => {
        if (laborGroupOptions.length > 0 && value) {
            const found = laborGroupOptions.find((option) => option.id === value);
            if (found) {
                setSelectedLaborGroup(found);
            }
        }
    }, [value, laborGroupOptions]);

    return (
        <Dropdown
            value={selectedLaborGroup}
            options={laborGroupOptions}
            onChange={handleSelectionChange}
            optionLabel="displayValue"
            showClear
            className={className}
            placeholder={placeholder || 'İşçilik Grubu seçiniz'}
            loading={isLoading}
            itemTemplate={(option) => <div>{option.text}</div>}
        />
    );
};

export default LaborGroupDropdown;
